import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ReadableNavButton } from "../Sticker";
import DemoResetPill from "./DemoResetPill";

/** Top row: back link + optional reset — no layout hacks. */
export default function DemoPageChrome({
  backTo,
  backLabel,
  showReset = true,
  resetVariant = "guest",
}) {
  return (
    <div className="flex items-start justify-between gap-3 mb-5">
      <ReadableNavButton
        as={Link}
        to={backTo}
        compact
        className="inline-flex items-center gap-1.5 shrink-0 min-h-[44px]"
      >
        <ArrowLeft className="w-4 h-4" aria-hidden />
        {backLabel}
      </ReadableNavButton>
      {showReset ? <DemoResetPill inline variant={resetVariant} /> : null}
    </div>
  );
}
